var properties, slideAmount;

jQuery(document).ready(function ($) {

  $('main').responsiveTables();
  // Images
  $('img').each(function () {
    var img = $(this);
    var src = $(this).attr('src');
    var alt = $(this).attr('alt');
    var filename = src.split('/').reverse()[0].replace(/\.[^/.]+$/, '');
    if (img.parent('a').length !== 0) {
      if (alt === '' || alt === undefined) {
        img.attr('alt', 'image ' + filename);
      }
    } else {
      if (alt === '' || alt === undefined) {
        img.attr('alt', '');
      }
    }
  });

  if ($('ul.breadcrumb li').length > 1) {
    $('.bc-expand').addClass('has-multiple');

    $('.bc-expand').on('click', function () {
      $('.breadcrumbs').focus();
      $('.breadcrumbs').addClass('bc-show-all');
    });

    $('.breadcrumbs').on('blur', function (e) {
      if (e.relatedTarget == null) {
        $('.breadcrumbs').removeClass('bc-show-all');
      }
    });
  }

  $('.toggle-nav').on('click', function () {
    $('.sidebar-nav').toggleClass('open-subnav');
  });

  $('.physicians-search > h2').on('click', function () {
    $('.physicians-search').toggleClass('open');
  });

  $('.rating-details-toggle').on('click', function (e) {
    e.stopPropagation();
    if ($('.rating-details-container').hasClass('open')) {
      $('.rating-details-container').removeClass('open');
      $(this).text('View Details');
    } else {
      $('.rating-details-container').addClass('open');
      $(this).text('Hide Details');
    }

  });

  $('.main-content').responsivevideos();
  $('.sidebar-content').responsivevideos();
  // Tables
  //$('main').responsiveTables();

  $('.results-filter .filter:first-child').on('click', function () {
    $('.results-filter').toggleClass('open');
  });

  if ($('.results-container').length > 0) {
    $('.results-container').masonry({ gutter: 20 });
  }

  $('.show-all').on('click', function () {
    var module = "";
    if ($(this).parent().hasClass('full-size')) {
      module = 'all';
    } else {
      module = $(this).data('module');
    }
    showHideResults(module);
  });

  if ($('.star-rating').length > 0) {
    var ratingPercentage = Math.round($('.overall-score > .star-rating').data('rating') * 20);
    $('.rating-upper').width(ratingPercentage + '%');
  }

  $('.location .btn.btn-primary').on('click', function () {
    var directions = $(this).data('maps-url');
    window.open(directions, '_blank');
  });

  $('.location-amenities .loc-show-all').on('click', function () {
    $(this).parent().toggleClass('open');
  });

  if ($('.location-amenities').length > 0) {
    if ($('.departments ul li').length > 5) {
      $(".departments .loc-show-all").removeClass('hidden');
    }

    if ($('.departments ul li').length == 0) {
      $('.departments').addClass('empty');
    }

    if ($('.providers ul li').length > 10) {
      $(".providers .loc-show-all").removeClass('hidden');
    }

    if ($('.providers ul li').length == 0) {
      $('.providers').addClass('empty');
    }
  }

  if ($('.quote-container').text().trim().length === 0) {
    $('.quote-container').hide();
  }

  //If Video bar is on the page, init it:
  if ($('.video-bar').length > 0) {

    $('.video-thumbnail').magnificPopup({
      type: 'iframe'
    });

    carousel = $('.video-bar').cycle(setSlideshowProperties());

    $(window).resize(function () {
      var oldSlide = properties.carouselVisible;
      var newProp = setSlideshowProperties(slideAmount);
      if (oldSlide != slideAmount) {
        $('.video-bar').cycle('destroy');
        $('.video-bar').cycle(newProp);
      }
    });
  }

  //Hide sidebar nav if empty
  if ($('.sidebar-nav > *').length <= 1) {
    $('.sidebar-nav').hide();
  }
});


function setSlideshowProperties(slideAmount) {

  var width = $(window).width();
  var height = $(window).height();

  if (width >= 768) {
    slideAmount = 4;
  } else if (width <= 360) {
    slideAmount = 1;
  } else {
    slideAmount = 2;
  }

  properties = {
    allowWrap: false,
    carouselVisible: slideAmount,
    swipe: true,
    carouselFluid: true,
    timeout: 0,
    slides: '.video',
    fx: 'carousel'
  };

  return properties;
}


//Hide Location Hours/Phone labels if empty
if ($('.sidebar .phone + ul').length == 0) {
  $('.sidebar .phone').hide();
}
if ($('.sidebar .hours + ul').length == 0) {
  $('.sidebar .hours').hide();
}
if ($('.sidebar-nav .ul1').length == 0) {
  $('.sidebar-nav').hide();
}

$('.cycle-slideshow').on('cycle-initialized', function (event, opts) {
  $('.slider-section').addClass('cycle-ready');
});

$('#pay-button').on('click', function () {
  InitPaymentForm();
});


function InitPaymentForm() {

  $("#pay-form").remove();

  var payform = document.createElement("form");

  payform.id = "pay-form";

  payform.method = "POST";

  //Retail
  payform.action = "https://www.sagepayments.net/eftcart/forms/express.asp";

  var accountInput = document.createElement("input");
  accountInput.name = "T_ordernum";
  accountInput.id = "pay-account-no";
  payform.appendChild(accountInput);

  var amountinput = document.createElement("input");
  amountinput.name = "T_amt";
  amountinput.id = "pay-amount";

  payform.appendChild(amountinput);
  payform.style = "display:none";


  var idInput = document.createElement("input");
  amountinput.name = "M_id";
  amountinput.id = "pay-id";

  document.body.appendChild(payform);

  $("#pay-account-no").val(document.getElementById('PayFormAccount').value);
  $("#pay-amount").val(document.getElementById('PayFormAmount').value);
  $("#pay-id").val(document.getElementById('PayFormId').value);
  $("#pay-form").submit();


}